module.exports = __webpack_public_path__ + "04_short_black.96cab9ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_short_black.png
// module id = SC9C
// module chunks = 0